'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _CollapsibleNav = require('./CollapsibleNav');

var _CollapsibleNav2 = _interopRequireDefault(_CollapsibleNav);

var CollapsableNav = _CollapsibleNav2['default'];

CollapsableNav.__deprecated__ = true;

exports['default'] = CollapsableNav;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/CollapsableNav.js
 ** module id = 201
 ** module chunks = 0
 **/